import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import CommonDataGrid from '../../Stateless/CommonDataGrid';
import ErrorHandler from '../../Stateless/Common/ErrorHandler';
import React from 'react';

const WalletHistory = () => {
  const location = useLocation() as any;
  const navigate = useNavigate();
  const wallet = location?.state?.wallet;

  const rows = React.useMemo(() => {
    const transactions = wallet?.recentTransactions || [];
    return transactions.map((tx: any, index: number) => ({
      id: tx.transactionId || `${index}`,
      transactionId: tx.transactionId,
      amount: tx.amount,
      type: tx.type,
      description: tx.description,
      status: tx.status,
      createdAt: tx.createdAt || tx.createdAtUtc || tx.created,
    }));
  }, [wallet]);

  const columns = [
    { field: 'transactionId', headerName: 'Transaction Id', flex: 1 },
    { field: 'type', headerName: 'Type', flex: 1 },
    { field: 'amount', headerName: 'Amount', flex: 1 },
    { field: 'status', headerName: 'Status', flex: 1 },
    { field: 'description', headerName: 'Description', flex: 2 },
    { field: 'createdAt', headerName: 'Date', flex: 1 },
  ] as any;

  return (
    <Box sx={{ p: 2, border: '1px solid #e0e0e0', marginTop: '20px', color: '#666' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <Typography variant="h6" fontWeight="bold">
          Wallet History - {wallet?.customerName}
        </Typography>
        <Button variant="outlined" onClick={() => navigate(-1)} size="small">
          Back
        </Button>
      </Box>

      <CommonDataGrid
        rows={rows}
        columns={columns}
        pageSize={10}
        onPageSizeChange={() => {}}
        checkboxSelection={false}
        components={{
          NoRowsOverlay: () => (
            <ErrorHandler type="no-data" message="No transactions found" onRetry={() => {}} />
          ),
        }}
      />
    </Box>
  );
};

export default WalletHistory;


